import request from "./http.js";
import { ytSysBase } from "@/config/api.js";
import { normalizeDeviceImeiPayload } from "@/utils/imei.js";
import { toServerDate } from "@/utils/time.js";
let userId = JSON.parse(sessionStorage.getItem("userId"));

//添加项目
export function addProject(data) {
  return request({
    url: ytSysBase + "/add-project",
    method: "post",
    data,
  });
}
// 编辑项目
export function updateProject(data) {
  return request({
    url: ytSysBase + "/projects/update-project",
    method: "post",
    data,
  });
}
// 删除项目
export function delProject(data) {
  return request({
    url: ytSysBase + "/del-project",
    method: "post",
    data,
  });
}
// 查询项目
export function getProject() {
  return request({
    url: ytSysBase + `/projects/project_info`,
    method: "get",
    // params: {},
  });
}

//添加设备
export function addDevice(data) {
  return request({
    url: ytSysBase + "/add-device",
    method: "post",
    data: normalizeDeviceImeiPayload(data),
  });
}
//编辑设备
export function updateDevice(data) {
  return request({
    url: ytSysBase + "/devices/update-device",
    method: "post",
    data: normalizeDeviceImeiPayload(data),
  });
}
//删除设备
export function delDevice(data) {
  return request({
    url: ytSysBase + "/del-device",
    method: "post",
    data,
  });
}
// 查询设备
export function getDevice(data) {
  return request({
    url: ytSysBase + `/devices/device_info`,
    method: "get",
    params: data,
  });
}

// 获取可从微信直接进入指定设备的小程序码（仅 dental 租户开放）。
export function getDeviceMiniProgramCode(deviceId) {
  return request({
    url: ytSysBase + `/devices/${deviceId}/mini-program-code`,
    method: "get",
  });
}
// 根据项目ID查询设备
export function getProjectDevices(projectId, data) {
  return request({
    url: ytSysBase + `/devices/project_devices/${projectId}`,
    method: "get",
    params: data,
  });
}

// 大楼组态 CRUD
export function getBuildingLayouts() {
  return request({ url: ytSysBase + "/building-layouts", method: "get" });
}
export function getBuildingLayout(id) {
  return request({ url: ytSysBase + "/building-layouts/" + id, method: "get" });
}
export function createBuildingLayout(data) {
  return request({ url: ytSysBase + "/building-layouts", method: "post", data });
}
export function updateBuildingLayout(id, data) {
  return request({ url: ytSysBase + "/building-layouts/" + id, method: "put", data });
}
export function deleteBuildingLayout(id) {
  return request({ url: ytSysBase + "/building-layouts/" + id, method: "delete" });
}

/**
 * @typedef {Object} RealtimePoint
 * @property {string} data JSON 编码的实时值与采集时间
 * @property {boolean} has_active_alarm 当前是否存在未恢复告警，与人工处理/已读状态无关
 * @property {number} weight
 * @property {string} icon
 * @property {string} unit
 * @property {string} value_type
 * @property {string} [preset_label]
 */
/**
 * 查询设备数据（每个点位携带服务端活动告警状态）。
 * @param {number} data 设备 ID
 * @returns {Promise<{code: number, data: Object<string, RealtimePoint>}>}
 */
export function queryDevicesData(data) {
  return request({
    url: ytSysBase + `/devices/queryData?device_id=${data}`,
    method: "get",
  });
}
// 查询点位
export function queryDataPoints(data, signal) {
  return request({
    url: ytSysBase + `/devices/queryDataPoints`,
    method: "get",
    params: data,
    signal,
  });
}
// 查询点位数据
export function queryHistoryData(data, signal) {
  return request({
    url: ytSysBase + `/devices/queryHistoryData`,
    method: "get",
    params: data,
    signal,
  });
}
/**
 * 按固定 24 小时时间窗分页查询多点位原始历史数据。
 * @param {{
 *   device_id: number,
 *   point_ids: number[],
 *   start_time: string,
 *   end_time: string,
 *   cursor?: string,
 *   order?: 'asc'|'desc'
 * }} data
 */
export function queryHistoryPage(data) {
  return request({
    url: ytSysBase + `/devices/queryHistoryPage`,
    method: "post",
    data,
  });
}
// 今日用水量（最新累计 - 今日零点前最后累计值，后端带 Redis 缓存）
export function getTodayWaterUsage(data) {
  return request({
    url: ytSysBase + `/devices/todayWaterUsage`,
    method: "get",
    params: data,
  });
}
// 查询设备上下线记录
export function loginLog(data) {
  return request({
    url: ytSysBase + `/devices/loginLog`,
    method: "get",
    params: data,
  });
}

// 查询用户的设备情况
export function getDevicesStatus(data) {
  return request({
    url: ytSysBase + `/devices/devicesStatus`,
    method: "get",
    params: data,
  });
}
// 查询用户的设备情况
export function getprojectNum(data) {
  return request({
    url: ytSysBase + `/projects/project_num/${userId}`,
    method: "get",
    params: data,
  });
}
// 获取下发命令列表
export function getCommandList(data) {
  return request({
    url: ytSysBase + `/devices/queryCommand`,
    method: "post",
    data,
  });
}
// 下发操作
export function issueCommand(data) {
  return request({
    url: ytSysBase + `/devices/sendCommand`,
    method: "post",
    data,
  });
}
// 通用 MQTT 命令下发（如重启 reboot）
export function sendGenericCommand(data) {
  return request({
    url: ytSysBase + `/devices/sendGenericCommand`,
    method: "post",
    data,
  });
}

// 批量添加设备
export function batchAddDevices(data) {
  return request({
    url: ytSysBase + `/add-devices`,
    method: "post",
    data: normalizeDeviceImeiPayload(data),
  });
}

// 批量修改设备
export function batchEditDevices(data) {
  return request({
    url: ytSysBase + `/devices/update-devices`,
    method: "post",
    data: normalizeDeviceImeiPayload(data),
  });
}
// 查询历史命令
export function queryCommandHistory(data) {
  return request({
    url: ytSysBase + `/devices/queryCommandHistory`,
    method: "post",
    data,
  });
}

// 获取项目设备数量统计
export function getTopProjectsByDeviceCount() {
  return request({
    url: ytSysBase + '/projects/top-by-device-count',
    method: 'get'
  })
}

// 获取近7天报警统计
export function getWeeklyAlarmCount() {
  return request({
    url: ytSysBase + '/alarms/weekly-count',
    method: 'get'
  })
}

// 查询设备告警记录
export function getAlarmLog(params) {
  return request({
    url: ytSysBase + '/devices/alarmLog',
    method: 'get',
    params
  })
}

// 删除报警记录
export function deleteAlarmLog(id) {
  return request({
    url: ytSysBase + '/devices/deleteAlarmLog',
    method: 'post',
    data: { id }
  });
}

// 处理报警（单条）
// data: { id, handle_status (0/1), handle_result }
export function handleAlarm(data) {
  const requestData = {
    "alarm_id": data.id,
    "handle_status": data.handle_status,
    "handle_result": data.handle_result
  }
  return request({
    url: ytSysBase + '/devices/handleAlarm',
    method: 'post',
    data: requestData
  })
}

// 按筛选条件批量处理告警
// params: { handle_status, handle_result, device_id, device_name, start_time, end_time }
export function batchHandleAlarms(params) {
  return request({
    url: ytSysBase + '/alarms/batch-handle',
    method: 'post',
    data: params
  })
}

// 设置设备维护状态
export function setMaintenance(data) {
  return request({
    url: ytSysBase + '/devices/setMaintenance',
    method: 'post',
    data: {
      ...data,
      lastMaintenanceDate: toServerDate(data.lastMaintenanceDate)
    }
  })
}

// ========== 告警轮询相关API ==========
/** @param {{view?: 'poll'|'counts', after_id?: number, day?: string}} [params] */
export function getUnreadAlarms(params) {
  return request({
    url: ytSysBase + '/alarms/unread',
    method: 'get',
    params
  })
}

// 按通知 ID 标记已读；同一告警的触发与恢复拥有不同 notification_id
export function markAlarmNotificationsAsRead(notificationIds) {
  return request({
    url: ytSysBase + '/alarms/mark-read',
    method: 'post',
    data: { notification_ids: notificationIds }
  })
}

// 一键把当前用户所有未读告警全部置为已读
export function markAllAlarmsRead() {
  return request({
    url: ytSysBase + '/alarms/mark-all-read',
    method: 'post'
  })
}

// 获取当前用户未读的设备上线/离线通知
export function getUnreadDeviceStatusNotifications() {
  return request({
    url: ytSysBase + '/notifications/device-status/unread',
    method: 'get'
  })
}

// 一键把当前用户所有未读设备上下线通知置为已读
export function markAllDeviceStatusNotificationsRead() {
  return request({
    url: ytSysBase + '/notifications/device-status/mark-all-read',
    method: 'post'
  })
}
